<template>
  <div
    :class="[
      'content-block text-left',
      !embedded ? 'py-xl' : '',
      css,
      isBlog ? 'container' : ''
    ]"
  >
    <div v-if="image && !isBlog" class="content-block--image">
      <img :src="`${$imageFolder}/${image}`" :alt="title" :title="title" />
    </div>
    <div class="content-block--inner">
      <div v-if="isBlog" class="titles pb-xl">
        <h1 v-if="title && includeTitle" v-text="title"></h1>
        <h3 class="text--s pt-xs" v-if="sub_title" v-text="sub_title"></h3>
      </div>
      <div
        v-else-if="(title && includeTitle) || sub_title"
        class="titles pb-xl"
      >
        <h3 v-if="title && includeTitle" v-text="title"></h3>
        <h4 class="text--m pt-xs" v-if="sub_title" v-text="sub_title"></h4>
      </div>
      <div
        v-if="properties && properties.list"
        class="content-block--text text--s pb-l"
      >
        <contacts-block :list="listByContinent(title)" />
      </div>
      <template v-else>
        <!-- <div class="content-block--text text--s" v-html="summary || content"></div> -->
        <div
          class="content-block--text text--s pb-l has-style"
          v-html="content || summary"
        ></div>
      </template>

      <abtn
        :class="['mr-l']"
        v-for="button in children"
        :key="button.title"
        v-bind="button"
      >
        <span v-text="button.title"></span>
      </abtn>
    </div>
  </div>
</template>
<script>
import ContactsBlock from "@/components/contact/ContactsBlock.vue";
export default {
  props: {
    excludeTitle: {
      type: Boolean,
      default: false
    },
    embedded: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    sub_title: {
      type: String,
      default: null
    },
    content: {
      type: String,
      required: true
    },
    css: {
      type: String,
      default: null
    },
    properties: {
      type: Object,
      default: null
    },
    summary: {
      type: String,
      default: null
    },
    children: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: {
    ContactsBlock
  },
  methods: {
    listByContinent(cont) {
      console.log("Continent > ", cont);

      let _list = _.sortBy(
        this.list.filter(item => item.continent === cont),
        "title"
      );
      console.log("list > ", _list);
      return _list;
    }
  },
  computed: {
    list() {
      if (this.properties && this.properties.list) {
        let _prop = this.properties.list;
        return this.$store.state[_prop];
        // return "yay";
      }
      return [];
    },
    isBlog() {
      return this.css && this.css.indexOf("blog") > -1;
    },
    includeTitle() {
      if (this.properties && _.isBoolean(this.properties.excludeTitle)) {
        return !this.properties.excludeTitle;
      }
      return !this.excludeTitle;
    }
  }
};
</script>
<style lang="stylus">
.content-block
  .btn:not(:last-child)
    marg('m', bottom)
  _flex(row, wrap, flex-start, space-between)
  & > *:first-child
    flex 0 0 30%
    max-width 30%
  & > *:last-child
    flex 0 0 65%
    max-width 65%
  & > *:first-child:last-child
    max-width 100%
    flex 1
  +below(415px)
    & > *
      &:first-child
      &:last-child
        max-width 100%
        flex 0 0 100%
  &.blog-mode
    p
      line-height 1.6
      // text-align justify
  figure
    padding 0
    margin 0
  img
    max-width 100%
    background #e3e3e3
  &--text
    text-align left
    a
    a:visited
      color blue_5
      +desktop()
        &:hover
          color blue_6
    figure
      padding 0
      margin 0
    img
      max-width 100%
    ul
      padding-left 0px !important
</style>
